import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import BAIconbutton from "./BAIconbutton";
import BALoader from "./BALoader";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import "./components.css";
import nodata from "../../assets/nodatafound.png";
import moment from "moment";
import { useState } from "react";

function BAGrid(props) {
  const { datasource, gridCols, loading, isGrouping, groupName, tableClass, customCard } = props;
  let groupedList;

  if (isGrouping && datasource.length > 0) {
    for (let i = 0; i < datasource.length; i++) {
      datasource[i]['rowIndex'] = i
    }
    const groupedData = datasource.reduce((result, obj) => {
      const key = obj[groupName];
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push({ ...obj });
      return result;
    }, {});

    groupedList = Object.entries(groupedData)
  }

  return (
    <>
      {loading ? (
        <BALoader />
      ) : datasource && datasource.length < 1 ? (
        <div className="d-flex justify-content-center align-items-center">
          <img src={nodata} width="30%" />
        </div>
      ) : (
        <Box>
          {
            isGrouping && groupName ? <>
              {
                groupedList.map((f, fieldsetIndex) => <div className="row" key={fieldsetIndex}>
                  <div className="col-md-3">
                    <div>
                      <p style={{ borderRadius: '0 30px 30px 0' }} className="fw-bold m-0 p-1 bgLight">{f[0]}</p>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="px-2">
                      <table className={`table topRounded ${tableClass ?? "table-striped"} text-start overflow-hidden`}>
                        <thead className="bgPrimary text-white">
                          <tr>
                            {Array.isArray(gridCols)
                              ? gridCols.map((e, i) => <th key={i}>{e.label}</th>)
                              : null}
                          </tr>
                        </thead>
                        <tbody className="gridBody">
                          {Array.isArray(f[1])
                            ? f[1].map((e, i) => (
                              <tr style={{ verticalAlign: "bottom" }} key={i}>
                                {gridCols
                                  ? gridCols.map((a, b) => (
                                    <td
                                      className={
                                        a.className
                                          ? a.className
                                          : ""
                                      }
                                      key={b}
                                    >
                                      {a.displayField
                                        ? a.displayField(e, e.rowIndex)
                                        : a.displayType == "date"
                                          ? moment(e[a.key]).format("DD/MMM/YYYY")
                                          : e[a.key]}
                                    </td>
                                  ))
                                  : null}
                              </tr>
                            ))
                            : null}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>)
              }
            </>
              : customCard ? <Box className='customCardParent'> {datasource.map((x, i) => customCard(x, i))} </Box> : <table className="table rounded overflow-hidden shadow table-striped text-start">
                <thead className="bgPrimary text-white">
                  <tr>
                    {Array.isArray(gridCols)
                      ? gridCols.map((e, i) => <th key={i}>{e.label}</th>)
                      : null}
                  </tr>
                </thead>
                <tbody className="gridBody">
                  {Array.isArray(datasource)
                    ? datasource.map((e, i) => (
                      <tr style={{ verticalAlign: "bottom" }} key={i}>
                        {gridCols
                          ? gridCols.map((a, b) => (
                            <td
                              className={
                                a.editRow || a.deleteRow
                                  ? "btnCell"
                                  : a.className
                                    ? a.className
                                    : ""
                              }
                              key={b}
                            >
                              {a.displayField
                                ? a.displayField(e, i)
                                : a.displayType == "date"
                                  ? moment(e[a.key]).format("DD/MMM/YYYY")
                                  : e[a.key]}
                            </td>
                          ))
                          : null}
                      </tr>
                    ))
                    : null}
                </tbody>
              </table>
          }
          {/* <table className="table rounded shadow table-striped text-start">
            <thead className="bgPrimary">
              <tr>
                {Array.isArray(gridCols)
                  ? gridCols.map((e, i) => <th key={i}>{e.label}</th>)
                  : null}
              </tr>
            </thead>
            <tbody className="gridBody">
              {Array.isArray(datasource)
                ? datasource.map((e, i) => (
                  <tr style={{ verticalAlign: "bottom" }} key={i}>
                    {gridCols
                      ? gridCols.map((a, b) => (
                        <td
                          className={
                            a.editRow || a.deleteRow
                              ? "btnCell"
                              : a.className
                                ? a.className
                                : ""
                          }
                          key={b}
                        >
                          {a.displayField
                            ? a.displayField(e, i)
                            : a.displayType == "date"
                              ? moment(e[a.key]).format("DD/MMM/YYYY")
                              : e[a.key]}
                        </td>
                      ))
                      : null}
                  </tr>
                ))
                : null}
            </tbody>
          </table> */}
        </Box>
      )}
    </>
  );
}
export default BAGrid;
